import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Grid } from "semantic-ui-react";

import * as util from "../../shared/utility";
import * as actions from "../../actions";

import ProjectBreadcrumb from "../breadcrumb/ProjectBreadcrumb";
import StandardTableHeader from "../UI/StandardHeader";

class CalculationList extends React.Component {
  componentDidMount() {
    const { projectid } = this.props.match.params;
    this.props.fetchCalculationsForProject(projectid);
  }

  componentWillUnmount() {
    this.props.unloadCalculations();
  }

  renderTable() {
    let calculationslist = null;

    if (this.props.calculations.length !== 0) {
      calculationslist = this.props.calculations
        .sort((a, b) =>
          b.lastUpdatedDateTime.localeCompare(a.lastUpdatedDateTime)
        )
        .map((calculation) => {
          return (
            <tr key={calculation.calculationID}>
              <td className="mobile hidden">{calculation.calculationID}</td>
              <td>
                <Link
                  className="item"
                  to={`/sales/calculations/detail/${calculation.calculationID}`}
                >
                  <div className="item">{calculation.name}</div>
                </Link>
              </td>
              <td className="center aligned">
                {calculation.revenuePercentage}
              </td>
              <td className="center aligned mobile hidden">
                {util.utcStringToLocalDateTime(calculation.lastUpdatedDateTime)}
              </td>
              <td>
                <Link
                  className="item"
                  to={`/sales/calculations/edit/${calculation.calculationID}`}
                  key={calculation.calculationID}
                >
                  <i className="edit icon" title="Edit record." />
                </Link>
              </td>
              <td>
                <i
                  style={{ cursor: "pointer" }}
                  className="copy icon blue"
                  onClick={() =>
                    this.props.copyCalculation(calculation.calculationID)
                  }
                  title="Copy record."
                />
              </td>
              <td>
                <Link
                  className="item"
                  to={`/sales/calculations/delete/${calculation.calculationID}`}
                  key={calculation.calculationID}
                >
                  <i className="trash icon" title="Delete record." />
                </Link>
              </td>
            </tr>
          );
        });
    }

    return (
      <div>
        <table className="ui celled table unstackable">
          <thead>
            <tr>
              <th className="one wide mobile hidden">ID</th>
              <th className="nine wide">Name</th>
              <th className="two wide center aligned">%</th>
              <th className="three wide center aligned mobile hidden">
                Changed
              </th>
              <th className="one wide center aligned" colSpan="3">
                Action
              </th>
            </tr>
          </thead>
          <tbody>{calculationslist}</tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <StandardTableHeader headerLabel="Calculations">
              <ProjectBreadcrumb
                projectID={this.props.match.params.projectid}
                currentPath="Calculations"
              />
            </StandardTableHeader>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>{this.renderTable()}</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    calculations: state.calculations.items,
    isMobile: state.utility.isMobile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCalculationsForProject: (id) =>
      dispatch(actions.fetchCalculationsForProject(id)),
    copyCalculation: (id) => dispatch(actions.copyCalculation(id)),
    unloadCalculations: () => dispatch(actions.unloadCalculations()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalculationList);
